import React from 'react';
import PropTypes from 'prop-types';

import { Error500Message } from '@febos-io/design';

export class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    const { state, props } = this;
    if (state.hasError) return <Error500Message />;

    return props.children;
  }
}

GlobalErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
};

export default GlobalErrorBoundary;
